import { studioCloseRestrictionText } from 'Const/studio/text';
import { useModal } from 'Store/modal';

const useCloseModalRestriction = () => {
  const { onOpenModal, onResetModal } = useModal();

  const onCloseRestriction = ({ submit }) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: studioCloseRestrictionText.title,
      contentDescription: studioCloseRestrictionText.description,
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: studioCloseRestrictionText.submitButton,
      secondaryButtonText: studioCloseRestrictionText.closeButton,
      onClickPrimaryButton: () => {
        submit?.();
        onResetModal();
      },
    });
  };

  return { onCloseRestriction };
};

export default useCloseModalRestriction;
